import { render, staticRenderFns } from "./UpdateImage.vue?vue&type=template&id=38031e2c&scoped=true&"
import script from "./UpdateImage.vue?vue&type=script&lang=js&"
export * from "./UpdateImage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateImage.vue?vue&type=style&index=0&id=38031e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38031e2c",
  null
  
)

export default component.exports